import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbInputCounter as ClbInputCounter_ } from '@celebration/design-system/dist/lib/input-counter';
const events = {
    onClbChange: ClbInputCounter_.events
        .onClbChange,
};
export const ClbInputCounter = createComponent({
    tagName: ClbInputCounter_.tagName,
    elementClass: ClbInputCounter_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map